import React from 'react';
import Types from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useTheme } from '@wise/components-theming';
import classNames from 'classnames';
var ButtonItem = function ButtonItem(_ref) {
  var translationKey = _ref.translationKey,
    link = _ref.link,
    inverse = _ref.inverse,
    deEmphasize = _ref.deEmphasize,
    linkTarget = _ref.linkTarget,
    active = _ref.active,
    isTabItem = _ref.isTabItem,
    isPillNavigation = _ref.isPillNavigation,
    onNavigationTypeChange = _ref.onNavigationTypeChange,
    children = _ref.children;
  var _useTheme = useTheme(),
    isModern = _useTheme.isModern;
  return /*#__PURE__*/React.createElement("li", {
    className: classNames('tw-public-nav__item', {
      'tw-public-nav__item--pill-open': isPillNavigation && active,
      'tw-public-nav__item--pill-close': isPillNavigation && !active
    })
  }, !isPillNavigation && /*#__PURE__*/React.createElement("a", {
    href: link,
    className: classNames('tw-public-nav__item-link btn btn-sm text-ellipsis', {
      'btn-active': active,
      'btn-priority-2': !active && deEmphasize && isModern,
      'btn-accent': isModern,
      'btn-link': deEmphasize && !isModern,
      'btn-default': inverse && !deEmphasize,
      'btn-primary': !inverse && !deEmphasize,
      'btn-tab': isTabItem && !isModern
    }),
    target: linkTarget
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: translationKey
  })), isPillNavigation && /*#__PURE__*/React.createElement("a", {
    href: link,
    className: classNames('tw-public-nav__item-link btn btn-accent btn-sm text-ellipsis', {
      'btn-active': active,
      'btn-priority-3': !active,
      'btn-default': inverse && !deEmphasize,
      'btn-primary': !inverse && !deEmphasize,
      'btn-accent btn-priority-1': isPillNavigation && active
    }),
    onClick: onNavigationTypeChange
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: translationKey
  })), children);
};
ButtonItem.defaultProps = {
  active: false,
  deEmphasize: false,
  isTabItem: false,
  linkTarget: undefined,
  isPillNavigation: false,
  onNavigationTypeChange: undefined,
  children: null
};
export default ButtonItem;